<div class="custom-toast-container" [ngClass]="toastPackage.toastType">
  <div class="toast-icon">
    <img [src]="iconUrl" alt="icon" class="toast-icon-img"/>
  </div>
  <div class="toast-message">
    <div>{{ toastPackage.message }}</div>
  </div>
  <button class="close-button" (click)="closeToast()" style="pointer-events: auto !important; cursor: pointer !important;">×</button>
</div>
